import { CircularProgress, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ICommonFormProps from "../../../../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import { generateRegister } from "../../../../../../../yoello-lib/modules/dynamicForms/utils";
import { useEffect } from "react";

interface ISearchEmail extends ICommonFormProps {
  onSearch: Function;
  isClear: boolean;
}
const SearchEmailInput = (props: ISearchEmail) => {
  const { t } = useTranslation();

  useEffect(() => {
    props.formProps?.error &&
      props.setError(props.keyName, {
        type: "manual",
        message: props.formProps?.error,
      });
    if (props.setValue && props.formProps?.isClear) props.setValue("email", "");
    // eslint-disable-next-line
  }, [props.formProps?.error, props.formProps?.isClear]);

  return (
    <TextField
      {...{
        type: "string",
        InputProps: {
          endAdornment:
            props.formProps?.userStatus === undefined ? (
              props.formProps?.isLoading ? (
                <CircularProgress size="2rem" color="inherit" />
              ) : (
                <button name="search" className="searchButton">
                  {t("checkUserStatus.buttons.search")}
                </button>
              )
            ) : (
              <></>
            ),
          disabled:
            props.formProps?.isLoading ||
            props.formProps?.userStatus !== undefined,
        },
      }}
      placeholder={t(props.inputProperties?.placeholder || "")}
      {...generateRegister(props)}
      style={{ width: "100%" }}
      disabled={props.disabled || false}
      name={props.keyName}
      error={props.errors ? true : false}
      data-component-name={props.keyName}
      className={props.className}
      InputLabelProps={{ shrink: true }}
      variant={props.inputProperties?.variant || "outlined"}
    />
  );
};

export default SearchEmailInput;
